import {
  Component,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  ComponentRef,
  EventEmitter,
  Output,
  Input,
  ChangeDetectorRef
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'inputlang',
    templateUrl: './inputlang.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
/**
 * API to an open modal window.
 */
export class InputLangComponent {
  /**
   * Caption for the title.
   */
  @Input() public title: string;
  @Input() public danger: string;
  /**
   * component which is to be loaded dynamically.
   */
  public component: any;
  /**
   * Describes if the modal contains Ok Button.
   * The default Ok button will close the modal and emit the callback.
   * Defaults to true.
   */
  public okButton = true;
  /**
   * Caption for the OK button.
   * Default: Ok
   */
  public okButtonText = 'Ok';
  /**
   * Describes if the modal contains cancel Button.
   * The default Cancelbutton will close the modal.
   * Defaults to true.
   */
  public cancelButton = true;
  public closeButton = true;
  /**
   * Caption for the Cancel button.
   * Default: Cancel
   */
  public cancelButtonText = 'Cancel';
  /**
   * if the modalMessage is true it will show the message inside modal body.
   */
  public modalMessage = true;
  /**
   * Some message/content can be set in message which will be shown in modal body.
   */
  @Input() public message: string;
  /**
   * if the value is true modal footer will be visible or else it will be hidden.
   */
  public modalFooter = true;
  /**
   * shows modal header if the value is true.
   */
  public modalHeader = true;
  /**
   * if the value is true modal will be visible or else it will be hidden.
   */
  public isOpen = false;
  /**
   * Emitted when a ok button was clicked
   * or when close method is called.
   */
  cmpRef: ComponentRef<any>;
  // @ViewChild(OpenDirective) componentDirective: OpenDirective;
  // @ViewChild('child', { read: ViewContainerRef}) target: ViewContainerRef;
  @Output() public modalOutput: EventEmitter<any> = new EventEmitter();
  @Output() public modalClosed: EventEmitter<any> = new EventEmitter();

  editForm: UntypedFormGroup;
  availableLanguages = [];

  constructor(
    public componentFactoryResolver: ComponentFactoryResolver,
    public viewContainer: ViewContainerRef,
    private cdf: ChangeDetectorRef
  ) {
    this.editForm = new UntypedFormGroup({
      lang: new UntypedFormControl('en')
    });
  }

  open(data?: any) {
    this.isOpen = true;
    this.cdf.detectChanges();
    this.availableLanguages = data.values;
    this.editForm = new UntypedFormGroup({
      lang: new UntypedFormControl(data.values[data.selectedIndex])
    });
  }

  /**
   *  close method dispose the component, closes the modal and optionally emits confirmOutput value.
   */
  close(data?: any) {
    this.dispose();
    if (data) {
      this.modalOutput.emit(data);
    } else if (this.modalClosed) {
      this.modalClosed.emit(null);
    }
  }

  /**
   *  ok method dispose the component, closes the modal and emits true.
   */
  submit() {
    this.dispose();
    this.modalOutput.emit(this.editForm.controls['lang'].value);
  }

  /**
   *  dispose method dispose the loaded component.
   */
  dispose() {
    this.isOpen = false;
    if (this.component !== undefined) {
      this.component.then((componentRef: ComponentRef<any>) => {
        componentRef.destroy();
        return componentRef;
      });
    }
  }
}
